import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=5bf717b0&scoped=true&"
import script from "./ActionCard.vue?vue&type=script&lang=js&"
export * from "./ActionCard.vue?vue&type=script&lang=js&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=5bf717b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf717b0",
  null
  
)

export default component.exports